var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaperFileText1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 36.6666H30.0001C31.8411 36.6666 33.3334 35.1743 33.3334 33.3333V16.3806C33.3334 15.4966 32.9822 14.6487 32.3571 14.0236L22.6431 4.30957C22.0179 3.68444 21.1701 3.33325 20.2861 3.33325H10.0001C8.15913 3.33325 6.66675 4.82564 6.66675 6.66659V33.3333C6.66675 35.1743 8.15913 36.6666 10.0001 36.6666Z",
    stroke: "#2D2926",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6667 4.1665V14.9998H31.6667",
    stroke: "#2D2926",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3335 28.3333H25.0002",
    stroke: "#2D2926",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3335 21.6665H25.0002",
    stroke: "#2D2926",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3335 15H15.0002",
    stroke: "#2D2926",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperFileText1);
export default __webpack_public_path__ + "static/media/paper-file-text 1.4efa1ef6806e9f87a1787adf46b807d1.svg";
export { ForwardRef as ReactComponent };